import { useEffect, useState } from "react";
import { API_URL } from "../config";
import { authFetch } from "../utils";

export function useGetFwiPrediction({ meteoId }) {
  const [prediction, setPrediction] = useState(null);
  const [isLoadingPrediction, setIsLoadingPrediction] = useState(true);
  const [errorPrediction, setErrorPrediction] = useState(null);

  useEffect(() => {
    if (!meteoId) return;

    const fetchPrediction = async () => {
      setIsLoadingPrediction(true);
      try {
        const res = await authFetch(`${API_URL}fwi/prediction/${meteoId}`);
        if (!res.ok) throw new Error("Error al obtener la predicción");
        const data = await res.json();
        setPrediction(data); // { meteoId, predictions: [...] }
      } catch (err) {
        console.error("Error cargando predicción:", err);
        setErrorPrediction(err);
      } finally {
        setIsLoadingPrediction(false);
      }
    };

    fetchPrediction();
  }, [meteoId]);

  return { prediction, isLoadingPrediction, errorPrediction };
}
